// src/pages/partner/PartnerTransportDashboard.jsx
import React from "react";
import { useTranslation } from "react-i18next";
import PartnerSpecialtyDashboard from "./PartnerSpecialtyDashboard";

export default function PartnerTransportDashboard() {
  const { t } = useTranslation();

  return (
    <PartnerSpecialtyDashboard
      specialtyKey="transport"
      title={`🚚 ${t("partner.transport.title")}`}
      subtitle={t("partner.transport.subtitle")}
      typeFilter={["transport_quote", "transport"]}
      accent="blue"
    />
  );
}
